import React from 'react'
import classes from '@src/styles/GrowthHub.module.css'
import classNames from 'classnames'

function GrowthHub() {
  const handleHub = () => {
    window.open(
      'https://support.getdimension.com/en_us/categories/provider-faq-HkPjq9kZi?themeId=62fa805cea71a0bf61be87de',
      '_blank',
    )
  }

  const resources = [
    {
      link: 'https://support.getdimension.com/en_us/how-to-sign-up-and-accept-your-first-job-S15urNCgo',
      title: 'Sign Up and Accept Your First Job',
    },
    {
      link: 'https://support.getdimension.com/en_us/how-do-i-claim-my-first-junk-removal-job-SJl8BEfrs',
      title: 'My First Waste Removal Job',
    },
    {
      link: 'https://support.getdimension.com/en_us/how-to-check-warrior-payout-HJjOBVRli',
      title: 'Check Provider Payout',
    },
    {
      link: 'https://support.getdimension.com/en_us/how-to-give-a-great-service-HJStw7Ms',
      title: 'Give a Great Service',
    },
  ]

  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <div className={classes.content}>
          <h2 className={classes.heading}>Learn, Grow and Succeed with Dimension</h2>
          <p className={classes.description}>
            Our Provider Growth Hub is packed full of resources to help you take your business to
            the next level, as well as answers to your most frequently asked questions.
          </p>
          <button className={classes.secondaryButton} onClick={handleHub}>
            Visit Provider Growth Hub
          </button>
        </div>
        <div className={classes.resourceContainer}>
          <h4 className={classNames(classes.heading, classes.listHeader)}>Provider Resource Hub</h4>
          {resources.map((resource) => (
            <div
              className={classes.resource}
              key={resource.link}
              onClick={() => window.open(resource.link, '_blank')}
            >
              <div>
                <h4 className={classNames(classes.heading, classes.resourceCategory)}>How to</h4>
                <h4 className={classNames(classes.heading, classes.resourceTitle)}>
                  {resource.title}
                </h4>
              </div>
              <div />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default GrowthHub
